import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ClickableCellComponent } from 'src/app/components/common/common-table/clickable-cell/clickable-cell.component';
import { TableColumn } from 'src/app/components/common/common-table/common-table.component';
import { CustomReport } from 'src/app/models/custom-report';
import { WorkflowContextService } from 'src/app/services';
import { ReportService } from 'src/app/services/report.service';

@Component({
  selector: 'app-custom-reports',
  templateUrl: './custom-reports.component.html',
  styleUrls: ['./custom-reports.component.css'],
  standalone: false
})
export class CustomReportsComponent implements OnInit {
  columns: TableColumn[];
  rows: any[];
  loading=true;
  errorMessage='';

  constructor(
    private _reportService: ReportService,
    public context: WorkflowContextService,
    private router: Router,
    private route: ActivatedRoute
  ) {}
  reports: CustomReport[];

  ngOnInit() {
    this.columns = [
      {
        key: 'name',
        label: 'Name',
        headerType: 'text',
        cellType: 'component',
        component: ClickableCellComponent,
        componentInputs: row => ({
          text: row.name,
          row: row
        }),
        componentOutputs: {
          clicked: rowData => this.onNameClick(rowData)
        }
      }
    ];
    this._reportService
      .getCustomReports(this.context.client.id)
      .subscribe(
      {
        next: report => {
        this.reports = report;
        this.rows = report;
        this.loading = false;
        },
        error: (err) => {
          console.error(err);
          this.loading = false;
          this.errorMessage = 'Failed to load report. Please try again.';
        }
      });
  }

  onNameClick(row: any) {
    this.router.navigate(
      [row.id],
      { relativeTo: this.route }
    );
  }
}
